
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "VerticalDivider",
})
export default class VerticalDivider extends Vue {
  @Prop({ type: String, default: '8px' }) margin!: string;
}
